export const SEARCH_URL = '/api/filter/proxy';
export const SEARCH_SUGGESTIONS_URL = `${SEARCH_URL}/autoComplete`;
export const SEARCH_CONTENT_URL = '/api/proxy/search/result';
export const KYOCERA_COMMERCE = '/kyocera-commerce/proxy';
export const SEARCH_COMMERCE_URL = `${KYOCERA_COMMERCE}/CatalogSearchApi`;
export const SEARCH_FIELD_DEBOUNCE = 300;
export const BASKET_API_URL = '/api/basketservice/proxy';
export const MYPAGE_API_URL = '/api/mypageservice/proxy';
export const ORDERSERVICE_API_URL = '/api/orderservice/proxy';
